import { RadioGroup, RadioGroupItem } from '@/legacy-src/components/ui/radio-group'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Label } from '@/src/domains/design-system/components/Label'
import { Text } from '@/src/domains/design-system/components/Text'
import type { SelfAssessmentQuestion } from '@/src/domains/self-assessments/schemas'

export interface SelfAssessmentWizardQuestionFieldProps {
  question: SelfAssessmentQuestion
  value: number | null
  error?: string
  onBlur: () => void
  onChange: (value: number) => void
}

export const SelfAssessmentWizardQuestionField = ({
  question,
  value,
  error,
  onBlur,
  onChange,
}: SelfAssessmentWizardQuestionFieldProps) => {
  const { t } = getTranslate()

  return (
    <fieldset className="border-0 p-0">
      <legend className="sr-only">{question.title}</legend>

      <RadioGroup
        value={value === null ? '' : String(value)}
        onBlur={onBlur}
        onValueChange={(nextValue) => onChange(Number(nextValue))}
        className="flex flex-col gap-3"
      >
        {question.choices.map((choice) => (
          <Label
            key={choice.value}
            weight="semibold"
            className="relative flex min-h-14 items-center rounded-xl border-2 border-sand-500 bg-sand-100 py-4 pl-14 pr-4 text-petrol-500 has-[[data-state=checked]]:border-peach-500 has-[[data-state=checked]]:bg-pink-500"
          >
            <RadioGroupItem
              value={String(choice.value)}
              className="absolute left-4 top-1/2 z-10 shrink-0 -translate-y-1/2"
            />

            {choice.label}
          </Label>
        ))}
      </RadioGroup>

      {error ? (
        <Text element="p" variant="sm" className="text-peach-800" role="alert">
          {t(error)}
        </Text>
      ) : null}
    </fieldset>
  )
}
